import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import GardenWorkAssignCard from './GardenWorkAssign'
import { Pie } from 'react-chartjs-2'
import { Pieoptions } from '../../../../../Helper/Data'
import { useAuthState } from '../../../../../Helper/Context'

export default function WorkProgress(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user


    // console.log(FinancialYearID)
    const navigate = useNavigate()
    const workAssignedNavigate = (name, screenFlag) => {
        if (name === "Deputy Municipal Commissioner (DMC)") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=DMC&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Garden Officer (GO / AGO)") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=GO_AGO&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Garden Assistant (GA)") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=GA&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Garden Supervisor (GS)") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=GS&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Assign") {
            if (activeButton == 0) {
                navigate(`/WorkAssignedDMCTable?name=${name}&Flag=Garden_WorkAssign&ApiFlag=Garden_WorkAssign&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            } else {
                navigate(`/WorkAssignedDMCTable?name=${name}&Flag=Civil_WorkAssign&ApiFlag=Civil_WorkAssign&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            }
        } else if (name === "Pending") {
            if (activeButton == 0) {
                navigate(`/WorkAssignedDMCTable?name=${name}&Flag=Garden_WorkAssignPending&ApiFlag=Garden_WorkAssignPending&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            } else {
                navigate(`/WorkAssignedDMCTable?name=${name}&Flag=Civil_WorkAssignPending&ApiFlag=Civil_WorkAssignPending&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            }
        } else if (name === "Completed") {
            if (activeButton == 0) {
                navigate(`/WorkAssignedDMCTable?name=${name}&Flag=Garden_WorkAssignCompleted&ApiFlag=Garden_WorkAssignCompleted&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            } else {
                navigate(`/WorkAssignedDMCTable?name=${name}&Flag=Civil_WorkAssignCompleted&ApiFlag=Civil_WorkAssignCompleted&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            }
        }
    }

    const [activeButton, setActiveButton] = useState(sessionStorage.getItem('Index') ? sessionStorage.getItem('Index') : 0);

    useLayoutEffect(() => {
        setActiveButton(sessionStorage.getItem('Index') ? sessionStorage.getItem('Index') : 0)
    }, [])

    const handleButtonClick = (index) => {
        sessionStorage.setItem('Index', index)
        setActiveButton(index);
    };

    const Receiveddata = {
        labels: ["Assign", "Pending", "Completed",],
        datasets: [
            {
                // label: '# of Votes',
                data: [
                    activeButton == 0 ? Countdata?.Garden_UploadAssignWork_Assign_TotalCount : Countdata?.Civil_UploadAssignWork_Assign_TotalCount,
                    activeButton == 0 ? Countdata?.Garden_UploadAssignWork_Pending_TotalCount : Countdata?.Civil_UploadAssignWork_Pending_TotalCount,
                    activeButton == 0 ? Countdata?.Garden_UploadAssignWork_Completed_TotalCount : Countdata?.Civil_UploadAssignWork_Completed_TotalCount
                ],
                backgroundColor: [
                    "#41b2b0",
                    "#f38242",
                    "#293d7c",

                ],
                borderColor: [
                    // '#28c8c1',
                    // '#172b4d',
                    // '#993366',
                    // '#593e89',
                    // '#94408e',
                    // '#c74382',
                    // '#fa5d00',
                    // '#529ad2',
                    // '#ffc137',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className='row m-1 p-0  bg-white   '>

            <div className=' mb-0  d-flex justify-content-between  '>
                <div>
                    <h5 className="pt-2 ">Civil Work Assign By Officials</h5>


                </div>

                <div className="btn-group m-0 float-end  " role="group" aria-label="Basic outlined example" style={{ border: '1px solid #154779', borderRadius: '5px' }}>


                    <button
                        onClick={() => handleButtonClick(0)}
                        className={activeButton == 0 ? "btn fw-bold  px-4 activebutton text-white" : "text-black fw-bold btn px-4"}
                        type="button">Garden</button>
                    <button
                        onClick={() => handleButtonClick(1)}
                        className={activeButton == 1 ? "btn fw-bold px-4 activebutton text-white" : "text-black fw-bold btn px-4"}
                        type="button">Civil</button>
                </div>

            </div>
            <div className='m-0 ' > <hr className="mt-2" style={{ color: "#a3964e" }}></hr></div>


            <div className="col-12 col-lg-7 pt-1 p-0 ">
                <div className='row ps-lg-3 pb-lg-0 px-2'>

                    <div className="col-12 col-md-6 col-lg-6">
                        <GardenWorkAssignCard
                            title="Assign"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/assignment.png'
                            count={activeButton == 0 ? Countdata?.Garden_UploadAssignWork_Assign_TotalCount : Countdata?.Civil_UploadAssignWork_Assign_TotalCount}
                            // navLink='/'
                            workAssignedNavigate={workAssignedNavigate}
                        />

                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                        <GardenWorkAssignCard
                            title="Pending"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/expired.png'
                            count={activeButton == 0 ? Countdata?.Garden_UploadAssignWork_Pending_TotalCount : Countdata?.Civil_UploadAssignWork_Pending_TotalCount}
                            // navLink='/'
                            workAssignedNavigate={workAssignedNavigate}
                        />

                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                        <GardenWorkAssignCard
                            title="Completed"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/approve.png'
                            count={activeButton == 0 ? Countdata?.Garden_UploadAssignWork_Completed_TotalCount : Countdata?.Civil_UploadAssignWork_Completed_TotalCount}
                            // navLink='/'
                            workAssignedNavigate={workAssignedNavigate}
                        />

                    </div>
                </div>
            </div>
            <div className="col-12 col-lg-5 pb-lg-2 mx-auto">
                {/* <div className="row">
                    <div className="col-12">
                        <div className="pb-0 upload_chart bg-white ">
                            <div className="row justify-content-center align-items-center "> */}
                <div className=" rounded-4 shadow-sm p-3 pt-2 mt-0 Chartborder h-100 ">

                    <div className="d-flex justify-content-center align-items-center  h-100 ">

                        {
                            (activeButton == 0 ? Countdata?.Garden_UploadAssignWork_Assign_TotalCount : Countdata?.Civil_UploadAssignWork_Assign_TotalCount != 0)
                                || (activeButton == 0 ? Countdata?.Garden_UploadAssignWork_Pending_TotalCount : Countdata?.Civil_UploadAssignWork_Pending_TotalCount != 0) ||
                                (activeButton == 0 ? Countdata?.Garden_UploadAssignWork_Completed_TotalCount : Countdata?.Civil_UploadAssignWork_Completed_TotalCount != 0) ?
                                <Pie
                                    height={100}
                                    // width={100}
                                    options={Pieoptions}
                                    data={Receiveddata}
                                />
                                :
                                <div className='text-danger   fw-bolder' style={{ height: '7vh', }}>
                                    <img
                                        className='wwork_img me-3'
                                        src="../assets/img/bar-graph.png"
                                    />
                                    <span className='mt-3' >No Data Found</span>
                                </div>

                        }
                        {/* </div>
                        </div>
                    </div>
                </div> */}
                    </div>
                </div>
            </div>
        </div>

    )

}

